export default "__VITE_ASSET__BA_b_Mt$__"